var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-span-1 flex flex-col cursor-pointer text-white"},[_c('div',{staticClass:"mx-auto items-center w-16 h-8 bg-gray-400 rounded-2xl p-1 flex flex-row space-x-1",class:{
      'bg-[#4E67EB]': _vm.trigger,
    }},[_c('div',{staticClass:"w-6 h-6 bg-white rounded-2xl",class:{ 'order-1': _vm.trigger }}),_c('div',[_c('p',{staticClass:"font-semibold mr-1"},[_vm._v(" "+_vm._s(_vm.trigger ? "YES" : "NO")+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }